export default __webpack_public_path__ + "static/connect-485ea2449a8966e273d8f57501267bae.svg";